import React from "react";
import "./Articlelistelement.css";

const ArticleListElement = ({ title, description, image, alttext, onClick }) => {
  return (
    <div className="article-list-element" onClick={onClick}>
      <img src={image} alt={alttext} />
      <div className="article-info">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default ArticleListElement;
